import type { QueryKey as RQQueryKey, UseSuspenseQueryOptions } from '@tanstack/react-query';
import { useSuspenseQuery } from '@tanstack/react-query';

export type SafeSuspenseQueryOptions<QueryFnData, Error, Data, QueryKey extends RQQueryKey> = Omit<
  UseSuspenseQueryOptions<QueryFnData, Error, Data, QueryKey>,
  'queryKey' | 'queryFn' | 'queryKeyHashFn'
>;

/**
 * @deprecated Use `createQueryOptions` and consume with `useSuspenseQuery` directly.
 * See packages/rest-api/README.md for the recommended pattern.
 */
export function createSuspenseQueryHook<
  Dependencies,
  QueryFnData = unknown,
  Error = unknown,
  Data = QueryFnData,
  QueryKey extends RQQueryKey = RQQueryKey,
>(queryFactory: (deps: Dependencies) => UseSuspenseQueryOptions<QueryFnData, Error, Data, QueryKey>) {
  return (deps: Dependencies, options?: SafeSuspenseQueryOptions<QueryFnData, Error, Data, QueryKey>) =>
    useSuspenseQuery({ ...options, ...queryFactory(deps) });
}
